"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundObject = void 0;
var SoundObject = /** @class */ (function () {
    function SoundObject() {
        // 表示済みの画像を管理するクラス
        this.audio = null;
        this.ctx = new AudioContext();
        this.source = this.ctx.createBufferSource();
        this.isPlaying = false;
        this.ctx = new AudioContext();
    }
    SoundObject.prototype.getAudio = function () {
        return this.audio;
    };
    SoundObject.prototype.setAudio = function (track) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, source;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // 画像の読み込みと表示処理
                        _a = this;
                        return [4 /*yield*/, this.ctx.decodeAudioData(track)];
                    case 1:
                        // 画像の読み込みと表示処理
                        _a.audio = _b.sent();
                        source = this.ctx.createBufferSource();
                        source.buffer = this.audio;
                        source.connect(this.ctx.destination);
                        return [2 /*return*/, this];
                }
            });
        });
    };
    SoundObject.prototype.getContext = function () {
        return this.ctx;
    };
    SoundObject.prototype.setContext = function (context) {
        this.ctx = context;
        return this;
    };
    SoundObject.prototype.getFileInfo = function () {
        // return filename, fileSize, playTime
        return;
    };
    SoundObject.prototype.setAudioAsync = function (src) {
        return __awaiter(this, void 0, void 0, function () {
            var arrayBuffer, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!src || src.length == 0) {
                            return [2 /*return*/, this];
                        }
                        return [4 /*yield*/, fetch(src)];
                    case 1: return [4 /*yield*/, (_b.sent()).arrayBuffer()];
                    case 2:
                        arrayBuffer = _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.ctx.decodeAudioData(arrayBuffer)];
                    case 3:
                        _a.audio = _b.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    // music control
    SoundObject.prototype.play = function (loop) {
        var _this = this;
        if (this.isPlaying) {
            this.stop();
        }
        if (!this.audio) {
            console.error('No audio loaded');
            return;
        }
        this.source = this.ctx.createBufferSource();
        this.source.buffer = this.audio;
        this.source.connect(this.ctx.destination);
        this.source.loop = loop;
        this.source.start(0);
        this.isPlaying = true;
        this.source.onended = function () {
            var _a;
            if (!((_a = _this.source) === null || _a === void 0 ? void 0 : _a.loop)) {
                _this.isPlaying = false;
            }
        };
    };
    SoundObject.prototype.stop = function () {
        if (this.source && this.isPlaying) {
            this.source.stop();
            this.source.disconnect();
            this.source = null;
            this.isPlaying = false;
        }
    };
    Object.defineProperty(SoundObject.prototype, "playing", {
        get: function () {
            return this.isPlaying;
        },
        enumerable: false,
        configurable: true
    });
    return SoundObject;
}());
exports.SoundObject = SoundObject;
//# sourceMappingURL=soundObject.js.map